export const reportsHubSeed = {
  categories: [
    { id: 'meetings', title: 'Meetings', description: 'Volume, cancellations, and outcomes.', path: 'reports/analytics', icon: 'calendar', roles: ['tenant_admin', 'scheduler', 'viewer'] },
    { id: 'utilization', title: 'Utilization', description: 'Rooms, organizers, and provider mix.', path: 'reports/utilization', icon: 'pie', roles: ['tenant_admin', 'scheduler', 'viewer'] },
    { id: 'channels', title: 'Channels', description: 'Teams, WhatsApp, and web adoption.', path: 'reports/analytics', icon: 'message', roles: ['tenant_admin', 'viewer'] },
    { id: 'ai', title: 'AI Summaries', description: 'Transcription minutes and MOM stats.', path: 'reports/analytics', icon: 'cpu', roles: ['tenant_admin'] },
    { id: 'compliance', title: 'Compliance', description: 'Exports and retention-related activity.', path: 'audit/exports', icon: 'shield', roles: ['tenant_admin', 'auditor'] },
  ],
  savedReports: [
    { id: 'sr1', name: 'Weekly utilization', lastRunAt: new Date(Date.now() - 86400000).toISOString(), runBy: 'sara@acme.example' },
    { id: 'sr2', name: 'Failed bookings', lastRunAt: new Date(Date.now() - 86400000 * 3).toISOString(), runBy: 'admin@acme.example' },
  ],
};

export const utilizationReportSeed = {
  byDepartment: [
    { dimension: 'Engineering', meetingCount: 420, pctShare: 38, avgDurationMin: 52, cancellationRate: 4.2 },
    { dimension: 'Sales', meetingCount: 280, pctShare: 25, avgDurationMin: 41, cancellationRate: 6.1 },
    { dimension: 'Operations', meetingCount: 310, pctShare: 28, avgDurationMin: 48, cancellationRate: 3.5 },
    { dimension: 'HR', meetingCount: 98, pctShare: 9, avgDurationMin: 35, cancellationRate: 2.0 },
  ],
  byOrganizer: [
    { dimension: 'Sara Al-Hinai', meetingCount: 190, pctShare: 22, avgDurationMin: 50, cancellationRate: 3.0 },
    { dimension: 'Ahmed Al-Balushi', meetingCount: 160, pctShare: 18, avgDurationMin: 44, cancellationRate: 5.2 },
    { dimension: 'Priya Menon', meetingCount: 140, pctShare: 16, avgDurationMin: 46, cancellationRate: 4.0 },
    { dimension: 'Others', meetingCount: 380, pctShare: 44, avgDurationMin: 47, cancellationRate: 4.5 },
  ],
  byProvider: [
    { dimension: 'Microsoft', meetingCount: 620, pctShare: 62, avgDurationMin: 49, cancellationRate: 4.0 },
    { dimension: 'Google', meetingCount: 380, pctShare: 38, avgDurationMin: 45, cancellationRate: 5.1 },
  ],
  donut: [
    { label: 'Microsoft', value: 62 },
    { label: 'Google', value: 38 },
  ],
};

export const meetingAnalyticsSeed = {
  metrics: {
    created: 1240,
    rescheduled: 89,
    cancelled: 74,
    conflicts: 23,
    transcriptSuccessPct: 91,
  },
  trendWeeks: ['W1', 'W2', 'W3', 'W4', 'W5', 'W6', 'W7', 'W8'],
  trendCreated: [120, 132, 118, 140, 155, 148, 160, 167],
  trendCancelled: [8, 10, 7, 9, 12, 11, 10, 9],
  trendConflicts: [2, 3, 4, 2, 3, 5, 2, 4],
  events: Array.from({ length: 30 }, (_, i) => ({
    id: `ev-${i}`,
    meetingTitle: `Meeting ${i + 1}`,
    date: new Date(Date.now() - i * 43200000).toISOString(),
    organizer: ['Sara Al-Hinai', 'Ahmed Al-Balushi'][i % 2],
    status: ['scheduled', 'cancelled', 'completed', 'failed'][i % 4],
    channel: ['Teams', 'WhatsApp', 'Web'][i % 3],
    department: ['Engineering', 'Sales', 'Ops'][i % 3],
  })),
};
